// Copyright (c) 2017 Deere & Company

import LeadAccount from './lead-account';
import t from 'tcomb';

const DealerHierarchyTerritory = t.struct({
    leadAccounts: t.list(LeadAccount, 'LeadAccounts'),
    territory: t.String
}, {
    name: 'DealerHierarchyTerritory',
    strict: true
});

export const getDefaultState = () => new DealerHierarchyTerritory({
    leadAccounts: [],
    territory: ''
});

export default DealerHierarchyTerritory;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-hierarchy-territory.js